import $axios from '../backend/vue-axios/axios.js'
const state = {
  searchResults: null,
  saveBulkEdit: {status: null, msg: ''},
  saveSearch: {status: null, msg: ''},
  formsManagement: {
    update: false,
    edit: false,
    issues: false,
    editContent: false,
    editIssues: false
  }
}
const mutations = {
  clearState (state) {
    state.searchResults = null
  },
  setSearchResults (state, payload) {
    state.searchResults = payload
  },
  setSaveBulkEdit (state, payload) {
    state.saveBulkEdit.status = true
    state.saveBulkEdit.msg = payload
  },
  setSaveSearch (state, payload) {
    state.saveSearch.status = true
    state.saveSearch.msg = payload
  },
  setFormStatus (state, payload) {
    state.formsManagement.update = payload.update
    state.formsManagement.edit = payload.edit
    state.formsManagement.editContent = payload.editContent
    state.formsManagement.issues = payload.issues
    state.formsManagement.editIssues = payload.editIssues
  },
  resetFormStatus (state) {
    state.formsManagement = {
      update: false,
      edit: false,
      issues: false,
      editContent: false,
      editIssues: false
    }
  }
}
const getters = {
  isSaveBulkEdit (state) {
    return state.saveBulkEdit
  },
  isSaveSearch (state) {
    return state.saveSearch
  },
  getSearchResults (state) {
    return state.searchResults
  },
  getFormStatus (state) {
    return state.formsManagement
  }
}
const actions = {
  searchObject ({commit}, payload) {
    var url = payload
    commit('clearState')
    $axios.get(url)
    .then(response => {
      commit('setSearchResults', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  resetStatus ({commit}) {
    commit('resetFormStatus')
  },
  closeForm ({commit}) {
    commit('resetFormStatus')
  },
  openForm ({commit}, payload) {
    commit('setFormStatus', payload)
  }
}
export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/search.js